import { GetStaticPaths, GetStaticProps } from 'next'
import React, { useEffect, useState } from 'react'
import { Document, documents, HowToUse, iconMap, progressIconMap } from '../../api/documents'
import { useTranslation } from 'react-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Header from '../../header';
import Footer from '../../footer';
import styles from "@/styles/DocumentDetail.module.css"
import SwiperArrow from '../../images/swiperArrow';
import Link from 'next/link';
import LoadingSpinner from '@/components/loading-spinner/loadingSpinner';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import "swiper/css";
import { markDocumentAsViewed } from '.';
import { useRouter } from 'next/router';
import PageSeo from '@/components/seo/PageSeo';

interface DocumentDetailProps {
  document: Document
  initialIndex: number;
}

const DocumentDetail: React.FC<DocumentDetailProps> = ({ document }) => {
  const { t } = useTranslation(['documentsTranslate', 'common']);
  const router = useRouter();
  const [translatedData, setTranslatedData] = useState<Document>(document);
  const [selectedDetail, setSelectedDetail] = useState<HowToUse>(document?.howToUse[0])
  const [currentIndex, setCurrentIndex] = useState(document?.initialIndex);
  const [isLoading, setIsLoading] = useState(true)
  const [progressData, setProgressData] = useState<Document[]>([]);

  const previousDocument = currentIndex > 0 ? documents[currentIndex - 1].link : documents[8].link;
  const nextDocument = currentIndex < documents.length - 1 ? documents[currentIndex + 1].link : documents[0].link;

  const minusIndexCheck = document?.initialIndex - 1 < 0 ? 8 : document?.initialIndex - 1
  const plusIndexCheck = document?.initialIndex + 1 > 8 ? 0 : document?.initialIndex + 1

  useEffect(() => {
    setTranslatedData(document);
    setSelectedDetail(document?.howToUse[0]);
    setCurrentIndex(document?.initialIndex)
    setProgressData(documents)
    setIsLoading(false)
  }, [document, documents]);

  useEffect(() => {
    markDocumentAsViewed(currentIndex);
  }, [currentIndex]);

  if (isLoading) {
    return <LoadingSpinner />
  }

  return (
    <>
      <PageSeo
        title={`${t(translatedData?.title)} | Stoneity`}
        description={translatedData?.description?.[0] ? t(translatedData.description[0]) : t('howToUse')}
        locale={router.locale}
        keywords={router.locale === "tr"
          ? "work management dokümanları, iş akışları, Stoneity dokümantasyon"
          : "work management documents, workflows, Stoneity documentation"
        }
      />
      <Header />
      <div className={styles.pageFlex}>
        <div className={styles.documentDetailWrapper}>
          <div className={styles.stepWrapper}>
            {progressData.map((doc, index) => {
              const viewedDocuments = JSON.parse(localStorage.getItem('workManagementViewedDocuments') || '[]');
              const isViewed = viewedDocuments.includes(doc.initialIndex);
              const IconComponent = progressIconMap[doc.icon as keyof typeof progressIconMap]
              return (
                <Link href={`/work-management/documents${doc.link}`} key={index} className={`${styles.stepperItem}`} onClick={() => setCurrentIndex(doc.initialIndex)}>
                  <div className={`${styles.stepIconWrapper} ${isViewed ? styles.completed : ""}`}>{IconComponent && <IconComponent color={isViewed ? "#fff" : "#03555E"} />}</div>
                  <div className={styles.stepName}>{t(doc.title)}</div>
                  <div className={styles.stepDoc}>(Doc {index + 1})</div>
                </Link>
              )
            }
            )}
          </div>
          <div className={styles.documentDetailTop}>
            <div className={styles.responsiveDocumentCounter}>Doc {document?.initialIndex + 1}</div>
            <Link className={styles.swiperArrowWrapper} href={`/work-management/documents${previousDocument}`} onClick={() => setCurrentIndex(minusIndexCheck)}><SwiperArrow /></Link>
            {t(translatedData?.title)}
            <Link className={styles.swiperArrowWrapper} href={`/work-management/documents${nextDocument}`} onClick={() => setCurrentIndex(plusIndexCheck)}><SwiperArrow /></Link>
          </div>
          <div className={styles.documentDetailMiddleContent}>
            <div className={styles.title}>{t('whatIs')}</div>
            <div className={styles.documentDetailMiddleContentDescs}>
              {translatedData?.description.map((desc, i) => (
                <div className={styles.description} key={i}>{t(desc)}</div>
              ))}
            </div>
            {
              document && document.specificIssueType && document.specificIssueType.length > 0 && (
                <>
                  {
                    document.specificIssueType.map((sType, i) => (
                      <div key={i}>
                        <div className={styles.title}>{t(sType.title)}</div>
                        <div className={styles.description}>{t(sType.description)}</div>
                      </div>
                    ))
                  }
                </>
              )
            }
          </div>
          {/* <div className={styles.documentDetailBottomContentWrapper}>
            <div className={styles.documentDetailBottomContentNav}>
              <div className={styles.title}>{document?.typeTitle ? t(document.typeTitle) : t('howToUse')}</div>
              <div className={styles.documentDetailBottomContentNavContent}>
                {translatedData?.howToUse.map((dHowToUse, index) => {
                  const IconComponent = iconMap[dHowToUse.icon as keyof typeof iconMap]
                  return (
                    <button className={`${styles.documentDetailBottomContentNavContentButton} ${selectedDetail.title === dHowToUse.title && styles.documentDetailBottomContentNavContentActiveButton}`} key={index} onClick={() => setSelectedDetail(dHowToUse)}>{IconComponent && <IconComponent color={selectedDetail.title === dHowToUse.title ? "#ffffff" : "#565656"} />} {t(dHowToUse.title)}</button>
                  )
                })}
              </div>
            </div>
            <div className={styles.documentDetailBottomContentNavSwiperWrapper}>
              <div className={styles.documentDetailBottomContentNavSwiperWrapperTitle}>{document?.typeTitle ? t(document.typeTitle) : t('howToUse')}</div>
              <Swiper
                slidesPerView={1}
                className={styles.documentDetailBottomContentNavMySwiper}
                modules={[Navigation]}
                navigation={{
                  prevEl: "." + styles.documentDetailBottomContentNavSlideWrapper,
                  nextEl: "." + styles.documentDetailBottomContentNavSlideWrapper2,
                }}
              >
                {translatedData?.howToUse.map((dHowToUse, index) => {
                  return (
                    <SwiperSlide key={index} style={{ height: 'auto' }}>
                      <div className={`${styles.documentDetailBottomContent} ${styles.responsiveDocumentDetailBottomContent}`} >
                        <div className={styles.title}>{t(dHowToUse?.title)}</div>
                        <div className={styles.description}>{t(dHowToUse?.description)}</div>
                        {
                          dHowToUse && dHowToUse.steps && dHowToUse.steps.length > 0 && (
                            <div className={styles.documentDetailBottomContentSteps}>
                              <div className={styles.title}>{t("fifthDocumentSteps")}</div>
                              <ul className={styles.documentDetailBottomSteps}>
                                {
                                  dHowToUse.steps?.map((step, i) => (
                                    <li key={i}><b>{t(step.title)}:</b> {t(step.description)}</li>
                                  ))
                                }
                              </ul>
                            </div>
                          )
                        }
                        <img className={styles.images} src="/knowledgeBase.png" alt="" />
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
              <div className={styles.documentDetailBottomContentNavSlideWrapper}>
                <div className={styles.documentDetailBottomContentNavCustomLeftArrow}></div>
              </div>
              <div className={styles.documentDetailBottomContentNavSlideWrapper2}>
                <div className={styles.documentDetailBottomContentNavCustomRightArrow}></div>
              </div>
            </div>
            <div className={styles.documentDetailBottomContent} >
              <div className={styles.title}>{t(selectedDetail?.title)}</div>
              <div className={styles.description}>{t(selectedDetail?.description)}</div>
              {
                selectedDetail && selectedDetail.steps && selectedDetail.steps.length > 0 && (
                  <div className={styles.documentDetailBottomContentSteps}>
                    <div className={styles.title}>{t("fifthDocumentSteps")}</div>
                    <ul className={styles.documentDetailBottomSteps}>
                      {
                        selectedDetail.steps?.map((step, i) => (
                          <li key={i}><b>{t(step.title)}:</b> {t(step.description)}</li>
                        ))
                      }
                    </ul>
                  </div>
                )
              }
              <img className={styles.images} src="/knowledgeBase.png" alt="" />
            </div>
          </div> */}
          <div className={styles.documentDetailWorkManagementBottomContent}>
            <div className={styles.documentDetailWorkManagementHowToUseContent}>
              <div className={styles.title}>{t("howToUse")}</div>
              <ol className={styles.documentDetailWorkManagementHowToUseTextWrapper}>
                {translatedData?.howToUse.map((dHowToUse, index) => {
                  return (
                    <li className={styles.documentDetailWorkManagementHowToUseText} key={index}>
                      <span>{t(dHowToUse.title)} {dHowToUse.description && ":"}</span>
                      {t(dHowToUse.description)}
                    </li>
                  )
                })}
              </ol>
            </div>
            <div className={styles.documentDetailWorkManagementTipsContent}>
              <div className={styles.title}>{t("workManagementTipsTitle")}</div>
              <ul className={styles.documentDetailWorkManagementTipsTextWrapper}>
                {translatedData?.tips.map((dtips, index) => {
                  return (
                    <li className={styles.documentDetailWorkManagementTipsText} key={index}>
                      {t(dtips.text)}
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default DocumentDetail

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = documents.map((document) => ({
    params: { document: document.link.substring(1) }
  }))
  return { paths, fallback: true }
}

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  const document = documents.find((document) => document.link.substring(1) === params?.document)

  if (!document) {
    return { notFound: true }
  }

  return {
    props: {
      document,
      ...(await serverSideTranslations(locale || 'en', ['common', 'documentsTranslate'])),
    }
  }
}
